import React from "react";
import MediaWrapper from "./MediaWrapper";
import TextRenderer from "src/app/components/commonComponents/TextRenderer";
import { Observation, TimelineData } from "src/shared/types/src";
import { format, parse } from "date-fns";
import { DATE_FORMATS } from "src/shared/config/src/lib/constants";

const ObservationItem: React.FC<{ label: string; value: string }> = ({
  label,
  value,
}) => {
  return (
    <div className="mg-t-20">
      <div className="fs-12 fs-regular text-black fw-bold text-underline">
        {label}
      </div>
      <div className="fs-12 text-black mg-t-10 opacity-75">
        <TextRenderer text={value || ""} />
      </div>
    </div>
  );
};

type ObservationItemWrapperProps = {
  observation: Observation;
  onMediaLoad: () => void;
};
const ObservationItemWrapper: React.FC<ObservationItemWrapperProps> = ({
  observation,
  onMediaLoad
}) => {
  const parsedDate = parse(
    observation?.timestamp,
    DATE_FORMATS.YMD_HMS,
    new Date()
  );
  const formattedTime = format(parsedDate, "d MMM yyyy");
  return (
    <div className="observation-item-wrapper-container">
      <div className="row">
        <div className="col-6 mg-b-10">
          <div className="observation-item-wrapper">
            <div className="fontMedium12">Submitted by:</div>
            <div className="fontBold14">{observation?.observationBy?.name}</div>
          </div>
        </div>
        <div className="col-6 justify-content-end d-flex mg-b-10">
          <div className="observation-item-wrapper">
            <div className="fontMedium12">Date:</div>
            <div className="fontBold14">{formattedTime}</div>
          </div>
        </div>
      </div>
      <MediaWrapper media={observation?.media || []} onMediaLoad={onMediaLoad} />
      {observation?.content ? (
        <>
          {observation?.content?.fieldOne?.value ? (
            <ObservationItem
              label={observation.content.fieldOne.label}
              value={observation.content.fieldOne.value}
            />
          ) : null}
          {observation?.content?.fieldTwo?.value ? (
            <ObservationItem
              label={observation.content.fieldTwo.label}
              value={observation.content.fieldTwo.value}
            />
          ) : null}
          {observation?.content?.fieldThree?.value ? (
            <ObservationItem
              label={observation.content.fieldThree.label}
              value={observation.content.fieldThree.value}
            />
          ) : null}
          {observation?.content?.fieldFour?.value ? (
            <ObservationItem
              label={observation.content.fieldFour.label}
              value={observation.content.fieldFour.value}
            />
          ) : null}
        </>
      ) : null}
    </div>
  );
};

export default ObservationItemWrapper;
